import React from "react";

function StateLights(props) {
  const getState = () => {
    switch (props.label) {
      case "used_sek1":
      case "used_sek2":
        return "used";
      case "in_progress":
        return "prog";
      default:
        return props.label;
    }
  };

  const titleTags = {
    active: "Noch nicht begonnen",
    prog: "Bereits begonnen",
    used: "Abgeschlossen",
    expired: "Abgelaufen"
  };

  return props.label === "expired" ? (
    <span>Abgelaufen</span>
  ) : (
    <span className={`state-lights ${getState()}`} title={titleTags[getState()]}>
      <span></span>
      <span></span>
      <span></span>
    </span>
  );
}
export default StateLights;
